// Web onboarding (online only, board 25 v2): a business STARTS on the web with
// no mobile app — one question per screen: role → phone → code → PIN
// (Authentik business-enrollment) → «ما اسمك؟» (the owner's own name) →
// the business in five questions (six with
// «عندك أكثر من فرع؟» when the platform has branches on) → hours
// (creates the business) → the shape step (team, shape 1) → «نشاطك جاهز» →
// «اليوم». Members: role → invite code → phone → code → PIN → «ضمن الفريق» /
// «بانتظار دعوة». Not a rail module: public routes mounted next to
// /auth/login, outside the authenticated shell (app/router.tsx). Each screen
// guards itself (no flow in flight → back to the phone; no session → the
// phone; node mode → /auth/login).

import type { RouteObject } from 'react-router-dom';
import { Navigate, useParams } from 'react-router-dom';
import { BranchesScreen } from './screens/Branches';
import { BusinessAddressScreen, BusinessCityScreen, BusinessNameScreen, BusinessPhoneScreen, BusinessTypeScreen } from './screens/Business';
import { DoneScreen } from './screens/Done';
import { HandoverScreen } from './screens/Handover';
import { HoursScreen } from './screens/Hours';
import { JoinScreen } from './screens/Join';
import { OtpScreen } from './screens/Otp';
import { OwnerNameScreen } from './screens/OwnerName';
import { PhoneScreen } from './screens/Phone';
import { PinScreen } from './screens/Pin';
import { RoleScreen } from './screens/Role';
import { ShapeStep } from './screens/shape/ShapeStep';
import { WorkdaysScreen } from './screens/Workdays';
import { ONB } from './data/flow';
import './onboarding.css';

export { ONB, onboardingAvailable } from './data/flow';
export { fetchIdentityName, IDENTITY_KEY } from './data/api';
export { onboardingStore } from './state';

/** The WhatsApp invite link (…/join/<token>) lands on the code screen, prefilled. */
function JoinLink() {
  const { token = '' } = useParams();
  return <Navigate to={`${ONB.join}?code=${encodeURIComponent(token)}`} replace />;
}

export const onboardingRoutes: RouteObject[] = [
  { path: ONB.role, element: <RoleScreen /> },
  { path: ONB.join, element: <JoinScreen /> },
  { path: '/join/:token', element: <JoinLink /> },
  { path: ONB.phone, element: <PhoneScreen /> },
  { path: ONB.otp, element: <OtpScreen /> },
  { path: ONB.pin, element: <PinScreen /> },
  { path: ONB.you, element: <OwnerNameScreen /> },
  { path: ONB.business, element: <Navigate to={ONB.name} replace /> },
  { path: ONB.name, element: <BusinessNameScreen /> },
  { path: ONB.type, element: <BusinessTypeScreen /> },
  { path: ONB.city, element: <BusinessCityScreen /> },
  { path: ONB.branches, element: <BranchesScreen /> },
  { path: ONB.address, element: <BusinessAddressScreen /> },
  { path: ONB.bphone, element: <BusinessPhoneScreen /> },
  { path: ONB.hours, element: <HoursScreen /> },
  { path: ONB.workdays, element: <WorkdaysScreen /> },
  { path: ONB.handover, element: <HandoverScreen /> },
  { path: ONB.shape, element: <ShapeStep /> },
  { path: ONB.done, element: <DoneScreen /> },
];
